const USERNAME_KEY = 'username';
const DISPLAY_NAME_KEY = 'displayName';
const ROLES_KEY = 'roles';

export const authSession = {
  getUsername() {
    return localStorage.getItem(USERNAME_KEY) ?? '';
  },
  getDisplayName() {
    return localStorage.getItem(DISPLAY_NAME_KEY) ?? '';
  },
  getRoles() {
    try {
      const roles = JSON.parse(localStorage.getItem(ROLES_KEY) ?? '[]');
      return Array.isArray(roles) ? roles : [];
    } catch {
      return [];
    }
  },
  hasSession() {
    return Boolean(localStorage.getItem(USERNAME_KEY));
  },
  setUsername(username: string) {
    localStorage.setItem(USERNAME_KEY, username);
  },
  setDisplayName(displayName: string | null) {
    if (displayName) localStorage.setItem(DISPLAY_NAME_KEY, displayName);
    else localStorage.removeItem(DISPLAY_NAME_KEY);
  },
  setRoles(roles: string[]) {
    localStorage.setItem(ROLES_KEY, JSON.stringify(roles));
  },
  setUser(username: string, displayName: string | null, roles: string[]) {
    this.setUsername(username);
    this.setDisplayName(displayName);
    this.setRoles(roles);
  },
  clear() {
    localStorage.removeItem(USERNAME_KEY);
    localStorage.removeItem(DISPLAY_NAME_KEY);
    localStorage.removeItem(ROLES_KEY);
  }
};
